import styled from 'styled-components';
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";

const DefaultBox = styled.span`
	position: absolute;
    text-align: center;
    margin-top: 120px;
    text-transform: uppercase;
    ${({theme}) => theme.font.presets.bold};
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const PcBox = DefaultBox;
const MobileBox = styled(DefaultBox)`
	margin-top: 105px;
`;

export const PartyJackpotWinCelebrationPopupContentContainerBox = styledByDevice(PcBox, MobileBox);